import {triggerBlobDownload} from '../lib/file-downloader';

export type VoiceTranscriptFormat = 'text' | 'markdown';

export type VoiceTranscriptLine = {
    role: 'user' | 'assistant';
    text: string;
};

type VoiceTranscriptExportOptions = {
    lines: VoiceTranscriptLine[];
    format: VoiceTranscriptFormat;
    voiceLabel: string;
    exportedAt?: Date;
};

const speakerLabel = (role: VoiceTranscriptLine['role']) =>
    role === 'user' ? 'User' : 'Assistant';

export const formatVoiceTranscript = ({
    lines,
    format,
    voiceLabel,
    exportedAt = new Date()
}: VoiceTranscriptExportOptions) => {
    const exportedLabel = exportedAt.toLocaleString();

    if (format === 'markdown') {
        const conversation = lines
            .map(line => `**${speakerLabel(line.role)}:** ${line.text}`)
            .join('\n\n');

        return [
            '# Theta Assist voice conversation',
            '',
            `**Exported:** ${exportedLabel}`,
            `**Voice:** ${voiceLabel}`,
            '',
            '## Transcript',
            '',
            conversation
        ].join('\n');
    }

    const conversation = lines
        .map(line => `${speakerLabel(line.role)}: ${line.text}`)
        .join('\n\n');

    return [
        'Theta Assist voice conversation',
        `Exported: ${exportedLabel}`,
        `Voice: ${voiceLabel}`,
        '',
        conversation
    ].join('\n');
};

export const downloadVoiceTranscript = (
    options: VoiceTranscriptExportOptions
) => {
    const extension = options.format === 'markdown' ? 'md' : 'txt';
    const mimeType =
        options.format === 'markdown'
            ? 'text/markdown;charset=utf-8'
            : 'text/plain;charset=utf-8';
    const exportedAt = options.exportedAt ?? new Date();
    const timestamp = exportedAt
        .toISOString()
        .replace(/\.\d{3}Z$/, 'Z')
        .replace(/[:]/g, '-')
        .replace('T', '_');
    const content = formatVoiceTranscript({...options, exportedAt});

    triggerBlobDownload(
        new Blob([content], {type: mimeType}),
        `theta-assist-voice-transcript_${timestamp}.${extension}`
    );
};
